// Landing / join screen. Player enters code + name, then hands off to the game view.
import { addBlobs, mountLangToggle, el, $ } from "./ui.ts";
import { initLang, t } from "./i18n.ts";

initLang();
addBlobs();
mountLangToggle();

const app = $("#app")!;

function render() {
  const card = el("div", { class: "card stack pop" });
  const logo = el("div", { class: "logo" });
  logo.innerHTML = `<span class="mascot">🐻</span> Quizzly`;

  const codeInput = el("input", {
    class: "input code",
    placeholder: "CODE",
    maxLength: 6,
    autocapitalize: "characters",
    autocomplete: "off",
  }) as HTMLInputElement;
  codeInput.addEventListener("input", () => {
    codeInput.value = codeInput.value.toUpperCase().replace(/[^A-Z0-9]/g, "").slice(0, 6);
  });

  const nameInput = el("input", {
    class: "input",
    placeholder: t("Your name"),
    maxLength: 20,
    autocomplete: "off",
  }) as HTMLInputElement;

  const err = el("div", { class: "error hidden" });

  const joinBtn = el("button", { class: "btn btn-block" }, t("Let's play! 🎉"));
  joinBtn.addEventListener("click", () => {
    const code = codeInput.value.trim();
    const name = nameInput.value.trim();
    if (code.length < 4) return showErr(t("Enter the game code"));
    if (!name) return showErr(t("Enter your name"));
    // Persist and hand off to the player game view.
    sessionStorage.setItem("quizzly_join", JSON.stringify({ code, name }));
    location.href = `/play?code=${encodeURIComponent(code)}`;
  });

  function showErr(m: string) {
    err.textContent = m;
    err.classList.remove("hidden");
  }

  card.append(
    logo,
    el("p", { class: "muted" }, t("Enter the code on the big screen to jump in.")),
    el("label", { class: "field" }, t("Game code")),
    codeInput,
    el("label", { class: "field" }, t("Nickname")),
    nameInput,
    err,
    joinBtn,
    el(
      "p",
      { class: "muted", style: { textAlign: "center", fontSize: "0.85rem", marginTop: "8px" } as any },
      "",
    ),
  );

  // Host/author link
  const hostLink = el("a", {
    href: "/studio",
    class: "muted",
    style: { textAlign: "center", display: "block", marginTop: "18px", textDecoration: "none" } as any,
  });
  hostLink.innerHTML = t("Running the quiz? <b>Host area →</b>");

  const wrap = el("div", { class: "stack" }, card, hostLink);
  app.replaceChildren(wrap);

  // Prefill code from ?code=
  const p = new URLSearchParams(location.search).get("code");
  if (p) codeInput.value = p.toUpperCase();
}

render();
